import { CtaStrip, MarketingPage, Pillars } from '../../components/MarketingPage';

export function About() {
  return (
    <MarketingPage
      seoTitle="About AuctiSync — The auction platform built for what's next"
      seoDescription="AuctiSync is a segmented-horizontal auction platform serving auction houses, lien-law facilities, business liquidators, and specialty collectibles dealers on one modern stack."
      canonicalPath="/about"
      eyebrow="About"
      headline="One platform, every kind of auction."
      subhead="AuctiSync is the auction platform the incumbents wouldn't build. We serve four segments — auction houses, facilities (lien-law), liquidators, and specialty dealers — on one modern stack with compliance, bidding, payments, and marketplace liquidity all built in."
    >
      <Pillars
        title="Our strategic pillars"
        items={[
          {
            title: 'Segmented horizontal',
            body: 'Four segment entry points. Same platform underneath. Each segment gets its own vocabulary + features without a separate SKU.',
          },
          {
            title: 'Anti-legacy positioning',
            body: '"Built for what\'s next" is not just a tagline. We\'ll never look like AuctionFlex or HiBid. Mobile-first, sub-200ms, flat subscription.',
          },
          {
            title: 'No per-bid fees. Ever.',
            body: 'The #1 complaint about every incumbent. We ship with a flat monthly subscription and marketplace % only on marketplace sales.',
          },
          {
            title: 'Compliance as a moat',
            body: 'State-specific lien-law compliance is hard. We built the engine once and scale it across verticals (storage, auto, RV, tow, marina, pawn).',
          },
          {
            title: 'Trustee-Grade as a flywheel',
            body: 'Court-grade sale infrastructure raises buyer confidence platform-wide. Every tenant benefits from a hammer-price lift.',
          },
          {
            title: 'Docs as Definition of Done',
            body: 'No feature ships without a help article, in-product tooltips, and a changelog entry. Docs never lag the product.',
          },
        ]}
      />

      <CtaStrip
        headline="Want to see how the segments map to your operation?"
        primaryLabel="See pricing"
        primaryHref="/pricing"
        secondaryLabel="Read the DTA case study"
        secondaryHref="/case-studies/dta"
      />
    </MarketingPage>
  );
}
